import { requirePermissionGuard } from "@/shared/rbac";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/zpetna-vazba")({
  beforeLoad: requirePermissionGuard("hca.feedback.read"),
});
